import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=2ff558ea"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"
import style0 from "./loading.vue?vue&type=style&index=0&id=2ff558ea&prod&scroped=true&lang=css"


/* normalize component */
import normalizer from "!../../ymoffers/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports